import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const namespaceRoutes: RouteRecordRaw[] = [
  {
    path: '/namespaces',
    children: [
      {
        path: '',
        name: RouteNames.Namespaces,
        component: () => import('@/views/namespaces/ListNamespaces.vue'),
        meta: {
          layout: Layouts.MODERN,
        },
      },
      {
        path: 'deprecated',
        name: RouteNames.DeprecatedNamespaces,
        component: () => import('@/views/deprecated/NamespaceView.vue'),
      },
      {
        path: ':namespaceId',
        name: RouteNames.NamespaceTemplate,
        component: () => import('@/views/NamespaceTemplateview.vue'),
      },
      {
        path: ':namespaceId/templates',
        redirect: (to) => ({
          name: RouteNames.NamespaceTemplate,
          params: {
            namespaceId: to.params.namespaceId,
          },
        }),
      },
      {
        path: ':namespaceId/templates/:templateId',
        name: RouteNames.Template,
        component: () => import('@/views/TemplateView.vue'),
      },
    ],
  },
];

export default namespaceRoutes;
